{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-410000",
  "sheetId": "StatementOfComprehensiveIncome",
  "label": "[410000] Statement of comprehensive income, net of tax (MPERS)",
  "description": "Statement of comprehensive income showing other comprehensive income items net of tax - MPERS",
  "taxonomy": "FS-MPERS",
  "controls": [
    {
      "qname": "ssmt-mpers:ComprehensiveIncomeNetOfTaxHeader",
      "label": "Comprehensive income net of tax",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 1
      }
    },
    {
      "qname": "ssmt-mpers:StatementOfComprehensiveIncomeNetOfTaxHeader",
      "label": "Statement of comprehensive income net of tax",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:StatementOfComprehensiveIncomeHeader",
      "label": "Statement of comprehensive income",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ifrs-smes:ProfitLoss",
      "label": "Profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "note": "Value inherited from the Statement of Profit or Loss (Role-12) `Profit (loss)` total. Value only — `linkTo.navigate: false` keeps the row label plain text until the P.O. enables field-link navigation.",
        "linkTo": {
          "role": "310000",
          "qname": "ifrs-smes:ProfitLoss",
          "navigate": false
        }
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherComprehensiveIncomeHeader",
      "label": "Other comprehensive income",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ifrs-smes:ComponentsOfOtherComprehensiveIncomeThatWillNotBeReclassifiedToProfitOrLossNetOfTaxHeader",
      "label": "Components of other comprehensive income that will not be reclassified to profit or loss, net of tax",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-smes:OtherComprehensiveIncomeNetOfTaxExchangeDifferencesOnTranslation",
      "label": "Other comprehensive income, net of tax, exchange differences on translation",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherComprehensiveIncomeNetOfTaxActuarialGainsLossesOnDefinedBenefitPlans",
      "label": "Other comprehensive income, net of tax, actuarial gains (losses) on defined benefit plans",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherComprehensiveIncomeNetOfTaxGainsLossesOnRevaluation",
      "label": "Other comprehensive income, net of tax, gains (losses) on revaluation",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:ShareOfOtherComprehensiveIncomeOfAssociatesAndJointVenturesAccountedForUsingEquityMethodThatWillNotBeReclassifiedToProfitOrLossNetOfTax",
      "label": "Share of other comprehensive income of associates and joint ventures accounted for using equity method",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:OtherComprehensiveIncomeThatWillNotBeReclassifiedToProfitOrLossNetOfTax",
      "label": "Total other comprehensive income that will not be reclassified to profit or loss, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= ExchangeDifferencesOnTranslation + ActuarialGainsLosses + GainsLossesOnRevaluation + ShareOfOCIOfAssociatesAndJV_NotReclassified",
        "dependencies": [
          "ifrs-smes:OtherComprehensiveIncomeNetOfTaxExchangeDifferencesOnTranslation",
          "ifrs-smes:OtherComprehensiveIncomeNetOfTaxActuarialGainsLossesOnDefinedBenefitPlans",
          "ifrs-smes:OtherComprehensiveIncomeNetOfTaxGainsLossesOnRevaluation",
          "ssmt-mpers:ShareOfOtherComprehensiveIncomeOfAssociatesAndJointVenturesAccountedForUsingEquityMethodThatWillNotBeReclassifiedToProfitOrLossNetOfTax"
        ]
      }
    },
    {
      "qname": "ifrs-smes:ComponentsOfOtherComprehensiveIncomeThatWillBeReclassifiedToProfitOrLossNetOfTaxHeader",
      "label": "Components of other comprehensive income that will be reclassified to profit or loss, net of tax",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ssmt-mpers:OtherComprehensiveIncomeNetOfTaxExchangeDifferencesOnTranslation",
      "label": "Other comprehensive income, net of tax, exchange differences on translation",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:OtherComprehensiveIncomeNetOfTaxChangeInFairValueOfHedgingInstrument",
      "label": "Other comprehensive income, net of tax, change in fair value of hedging instrument",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:ShareOfOtherComprehensiveIncomeOfAssociatesAndJointVenturesAccountedForUsingEquityMethodThatWillBeReclassifiedToProfitOrLossNetOfTax",
      "label": "Share of other comprehensive income of associates and joint ventures accounted for using equity method, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:OtherComprehensiveIncomeThatWillBeReclassifiedToProfitOrLossNetOfTax",
      "label": "Total other comprehensive income that will be reclassified to profit or loss, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= ExchangeDifferencesReclassified + ChangeInFairValueOfHedging + ShareOfOCIOfAssociatesAndJV_Reclassified",
        "dependencies": [
          "ssmt-mpers:OtherComprehensiveIncomeNetOfTaxExchangeDifferencesOnTranslation",
          "ssmt-mpers:OtherComprehensiveIncomeNetOfTaxChangeInFairValueOfHedgingInstrument",
          "ssmt-mpers:ShareOfOtherComprehensiveIncomeOfAssociatesAndJointVenturesAccountedForUsingEquityMethodThatWillBeReclassifiedToProfitOrLossNetOfTax"
        ]
      }
    },
    {
      "qname": "ssmt-mfrs:OtherComprehensiveIncomeNetOfTaxGainsLossesOnOtherItems",
      "label": "Others comprehensive income, net of tax, gains (losses) on other items",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "level": 4,
        "note": "Note: This field uses ssmt-mfrs prefix even in MPERS schema (as per backend DTO)"
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherComprehensiveIncome",
      "required": true,
      "label": "Total other comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "level": 4
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfChangesInEquity",
            "field": "ifrs-smes:OtherComprehensiveIncome"
          }
        ]
      },
      "calculation": {
        "formula": "= TotalNotReclassified + TotalReclassified + OtherItems",
        "dependencies": [
          "ssmt-mpers:OtherComprehensiveIncomeThatWillNotBeReclassifiedToProfitOrLossNetOfTax",
          "ssmt-mpers:OtherComprehensiveIncomeThatWillBeReclassifiedToProfitOrLossNetOfTax",
          "ssmt-mfrs:OtherComprehensiveIncomeNetOfTaxGainsLossesOnOtherItems"
        ]
      }
    },
    {
      "qname": "ifrs-smes:ComprehensiveIncome",
      "required": true,
      "label": "Total comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "level": 3
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfComprehensiveIncome",
            "field": "ifrs-smes:ComprehensiveIncome_2"
          },
          {
            "sheet": "statementOfChangesInEquity",
            "field": "ifrs-smes:ComprehensiveIncome"
          }
        ]
      },
      "calculation": {
        "formula": "= ProfitLoss + TotalOtherComprehensiveIncome",
        "dependencies": [
          "ifrs-smes:ProfitLoss",
          "ifrs-smes:OtherComprehensiveIncome"
        ]
      }
    },
    {
      "qname": "ifrs-smes:ComprehensiveIncomeAttributableToHeader",
      "label": "Comprehensive income attributable to",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ifrs-smes:ComprehensiveIncomeAttributableToOwnersOfParent",
      "label": "Comprehensive income, attributable to owners of parent",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "requiredIf": {
        "sheet": "filingPrerequisites",
        "field": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements",
        "equals": "Consolidated",
        "errorMessage": "When \"Nature of Financial Statements\" is \"Consolidated\", then \"Comprehensive income, attributable to owners of parent\" MUST be reported."
      }
    },
    {
      "qname": "ifrs-smes:ComprehensiveIncomeAttributableToNoncontrollingInterests",
      "label": "Comprehensive income, attributable to non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "requiredIf": {
        "sheet": "filingPrerequisites",
        "field": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements",
        "equals": "Consolidated",
        "errorMessage": "When \"Nature of Financial Statements\" is \"Consolidated\", then \"Comprehensive income, attributable to non-controlling interests\" MUST be reported."
      }
    },
    {
      "qname": "ifrs-smes:ComprehensiveIncome_2",
      "required": true,
      "label": "Total comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfComprehensiveIncome",
            "field": "ifrs-smes:ComprehensiveIncome"
          }
        ]
      },
      "calculation": {
        "formula": "= AttributableToOwners + AttributableToNCI",
        "dependencies": [
          "ifrs-smes:ComprehensiveIncomeAttributableToOwnersOfParent",
          "ifrs-smes:ComprehensiveIncomeAttributableToNoncontrollingInterests"
        ]
      }
    }
  ]
}
